import React from "react";
import {userApi} from "../User/userApi";
import {SignInView} from "./SignInView";
import {LayoutHero} from "../../Components/Layout/";
import {PageTitle} from "../../Components/Landmarks";

interface SignInContainerProps {
    handleApiCall: (...args: unknown[]) => void;
    isLoading: boolean;
    setLoggedInTrue: (user: Record<string, unknown>) => boolean;
    setWarnings: (val: string[]) => void;
}

export const SignInContainer: React.FC<SignInContainerProps> = ({
                                    handleApiCall,
                                    isLoading,
                                    setLoggedInTrue,
                                    setWarnings
                                }) => {

    const handleSignIn = (signInModel: Record<string, unknown>) => {
        handleApiCall(() => userApi.attemptLogin(signInModel), setLoggedInTrue);
    };

    return <>
        <LayoutHero>
            <PageTitle h1={`Sign In`}/>
            <SignInView handleSignIn={handleSignIn} isLoading={isLoading} setWarnings={setWarnings}/>
        </LayoutHero>
    </>
};
